import { createAsyncThunk, createSlice, isAnyOf } from "@reduxjs/toolkit";
import { PhotoWorkflowState } from "./photo-workflow.entity";
import { fetchPhotoWorkflow, insertPhotoWorkflow, orderPhotoWorkflow, removePhotoWorkflow } from "./photo-workflow.api";

export const getPhotoWorkflow = createAsyncThunk("photo-workflow/get", fetchPhotoWorkflow);

export const createPhotoWorkflow = createAsyncThunk("photo-workflow/create", insertPhotoWorkflow);

export const orderPhotoWorkflows = createAsyncThunk("photo-workflow/order", orderPhotoWorkflow);

export const deletePhotoWorkflow = createAsyncThunk("photo-workflow/delete", removePhotoWorkflow);

const initialState: PhotoWorkflowState = {
  list: [],
  loading: false,
  orderRequestId: null,
};

const photoWorkflowSlice = createSlice({
  name: "photo-workflow",
  initialState,
  reducers: {
    setListItems: (state, action) => {
      state.list = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(orderPhotoWorkflows.pending, (state, action) => {
        state.orderRequestId = action.meta.requestId;
      })
      .addCase(orderPhotoWorkflows.fulfilled, (state, action) => {
        if (action.meta.requestId !== state.orderRequestId) return;
        state.list = action.payload.data;
      })
      .addMatcher(isAnyOf(getPhotoWorkflow.pending, createPhotoWorkflow.pending, deletePhotoWorkflow.pending), (state) => {
        state.loading = true;
      })
      .addMatcher(isAnyOf(getPhotoWorkflow.rejected, createPhotoWorkflow.rejected, deletePhotoWorkflow.rejected), (state) => {
        state.loading = false;
      })
      .addMatcher(isAnyOf(getPhotoWorkflow.fulfilled, createPhotoWorkflow.fulfilled, deletePhotoWorkflow.fulfilled), (state, action) => {
        state.list = action.payload.data;
        state.loading = false;
      });
  },
});

export const { setListItems } = photoWorkflowSlice.actions;

export default photoWorkflowSlice.reducer;
